"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _LazyImage = _interopRequireDefault(require("@insided/shared/uikit/LazyImage"));

var _classnames = _interopRequireDefault(require("classnames"));

var _widgetContainer = require("@insided/deprecated-preact-components/widget-container");

var FeaturedCard = function FeaturedCard(_ref) {
  var title = _ref.title,
      label = _ref.label,
      _ref$showLabel = _ref.showLabel,
      showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel,
      featuredImage = _ref.featuredImage,
      featuredImageAlt = _ref.featuredImageAlt,
      titleSlot = _ref.titleSlot,
      children = _ref.children,
      hasWidgetSubtitle = _ref.hasWidgetSubtitle,
      hasWidgetTitle = _ref.hasWidgetTitle;
  var FeaturedCardHeaderTag = (0, _widgetContainer.genericWidgetHeaderTagCalculator)(hasWidgetTitle, hasWidgetSubtitle);
  return (0, _preact.h)("div", {
    className: "featured-topic__url card-widget-wrapper"
  }, (0, _preact.h)("div", null, showLabel && label && (0, _preact.h)("span", {
    className: (0, _classnames.default)('topic__content-type-pill', 'pill', 'pill--uppercase', 'pill--article', 'qa-content-type-pill')
  }, label), featuredImage && (0, _preact.h)("figure", null, (0, _preact.h)(_LazyImage.default, {
    type: "background",
    src: (0, _absoluteUrlRuntime.resolveUrl)(featuredImage),
    className: "featured-topic__hero",
    alt: featuredImageAlt
  }))), (0, _preact.h)("div", {
    className: "featured-topic__title"
  }, (0, _preact.h)(FeaturedCardHeaderTag, {
    className: (0, _classnames.default)('h3', 'featured-topic__heading', 'card-widget-title', {
      'featured-topic__heading--no-image': !featuredImage && label
    })
  }, title, titleSlot), children));
};

var _default = FeaturedCard;
exports.default = _default;